import React from 'react';
import { RotateCcw, ChevronRight, Rocket } from 'lucide-react';

const SectionControls = ({
  onReplay,
  onContinue,
  isLastSection = false,
  showControls = false,
  className = ''
}) => {
  if (!showControls) return null;

  return (
    <div className={`flex items-center justify-center gap-4 mt-8 animate-fadeInUp ${className}`}>
      {/* Replay Button - Ghost/White style */}
      <button
        onClick={onReplay}
        className="group flex items-center gap-2 px-5 py-2.5 bg-white border-2 border-slate-300 rounded-full shadow-md hover:shadow-lg hover:border-slate-400 transition-all duration-200"
        aria-label="Replay animation"
      >
        <RotateCcw className="w-4 h-4 text-slate-600 group-hover:text-slate-900 group-hover:rotate-[-360deg] transition-all duration-500" />
        <span className="text-sm font-medium text-slate-600 group-hover:text-slate-900">
          Replay
        </span>
      </button>

      {/* Continue/Get Started Button - Black with bouncing arrow */}
      <button
        onClick={onContinue}
        className="group flex items-center gap-2 px-5 py-2.5 bg-slate-900 text-white rounded-full shadow-lg hover:shadow-xl hover:bg-slate-800 transition-all duration-200"
        aria-label={isLastSection ? "Get started" : "Continue to next section"}
      >
        <span className="text-sm font-medium">
          {isLastSection ? "Let's Get Started" : "Continue"}
        </span>
        {isLastSection ? (
          <Rocket className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
        ) : (
          <ChevronRight className="w-4 h-4 animate-bounceHorizontal" />
        )}
      </button>

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes bounceHorizontal {
          0%, 100% {
            transform: translateX(0);
          }
          50% {
            transform: translateX(3px);
          }
        }

        .animate-fadeInUp {
          animation: fadeInUp 0.5s ease-out forwards;
        }

        .animate-bounceHorizontal {
          animation: bounceHorizontal 1.5s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default SectionControls;